<div class="">
    <img class="imageNoticiaHome" [src]="noticia.image || noticia.urlImage">
    <p class="small text-primary mb-0 my-2">{{noticia.fecha.toDate() | date}}</p>
    <p class="h6">{{noticia.titulo}}</p>
    <a class="btn btn-sm btn-outline-primary" [href]="noticia.url" target="blank">ver en portaldeturismo.pe</a>
</div>